var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M571.1,193.9c23.5,23.5,9.4,47.5-14.1,71l-32.8,32.8c-102.7,102.7,171,376.5,273.8,273.8l103.9-103.9 c147.8-147.8-195.5-491.1-343.3-343.3l-151,151c-1.2,1.2-2.4,2.4-3.5,3.6c-48.7,50.1-80.2,114.3-91.4,183.2l-7.7,47.5l227.9,227.9 l30.6,1.4c94.3,4.4,186.2-31.1,253-97.9l0,0c31.5-31.5,43.8-69,10-98.1l0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349.7,917.9L104,672.2c-23.9-23.9-23.9-62.6,0-86.5l95.3-95.3c23.9-23.9,62.6-23.9,86.5,0l245.7,245.7 c23.9,23.9,23.9,62.6,0,86.5l-95.3,95.3C412.3,941.8,373.5,941.8,349.7,917.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.3,689.5l52.4,52.4c16.8,16.8,16.8,44,0,60.8L337.1,905.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxing);
export default __webpack_public_path__ + "static/media/Boxing.c4cc6ab6163cd70d41159ebe7c8488e3.svg";
export { ForwardRef as ReactComponent };